import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Module-level cache so multiple components share one fetch round-trip.
let _cache = null;
let _inflight = null;

async function fetchMap() {
  if (_cache) return _cache;
  if (_inflight) return _inflight;
  _inflight = axios
    .get(`${API}/employees`, { withCredentials: true })
    .then(({ data }) => {
      const byId = {};
      (data || []).forEach((e) => {
        byId[e.id] = {
          employee_number: e.employee_number || '',
          name: e.name || '',
          name_en: e.name_en || '',
        };
      });
      _cache = byId;
      return byId;
    })
    .catch(() => ({}))
    .finally(() => { _inflight = null; });
  return _inflight;
}

/**
 * Returns a `{ user_id → employee_number }` lookup helper.
 *
 * Usage:
 *   const { empNo } = useEmployeesMap();
 *   empNo(user_id)  // → "1023" (or "—" if not yet loaded / unknown)
 */
export default function useEmployeesMap() {
  const [map, setMap] = useState(_cache || {});

  useEffect(() => {
    let alive = true;
    fetchMap().then((m) => {
      if (alive) setMap(m);
    });
    return () => { alive = false; };
  }, []);

  const empNo = (userId) => {
    if (!userId) return '—';
    return map[userId]?.employee_number || '—';
  };

  return { map, empNo };
}
